var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8332 2.66663V8.66663C11.8332 9.38663 11.4198 10.0066 10.8198 10.3066C10.8265 10.2066 10.8332 10.1066 10.8332 9.99996V3.99996C10.8332 2.43996 9.55984 1.16663 7.99984 1.16663H2.41984C2.7265 0.573293 3.33984 0.166626 4.05317 0.166626H9.33317C10.7132 0.166626 11.8332 1.28663 11.8332 2.66663ZM7.99984 2.16663H1.99984C0.988504 2.16663 0.166504 2.98863 0.166504 3.99996V9.99996C0.166504 11.0113 0.988504 11.8333 1.99984 11.8333H7.99984C9.01117 11.8333 9.83317 11.0113 9.83317 9.99996V3.99996C9.83317 2.98863 9.01117 2.16663 7.99984 2.16663Z",
    fill: "url(#paint0_linear_1452_10649)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1452_10649",
    x1: 5.99984,
    y1: 0.166626,
    x2: 5.99984,
    y2: 11.8333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0294F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0274BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCopy);
export default __webpack_public_path__ + "static/media/blue-copy.110435f979cc2e92192dc2ff36492ce2.svg";
export { ForwardRef as ReactComponent };